import { useEffect, useState } from "react";

import { getMailboxes } from "../api/mailboxApi";

const NONE = { available: false, canSend: false, canRead: false };

// One lookup per page load, shared by the sidebar and every email link on the page.
let statusPromise = null;

export function resetMailboxCanSend() {
  statusPromise = null;
}

/**
 * `available`: Gmail connection is set up on this server (hidden in the
 * sidebar until it is). `canSend`: the signed-in agent can send from their
 * own connected Gmail. `canRead`: the Mail section can show their inbox.
 */
export function useMailboxStatus() {
  const [status, setStatus] = useState(NONE);

  useEffect(() => {
    let alive = true;
    if (!statusPromise) {
      statusPromise = getMailboxes()
        .then((d) => ({
          available: Boolean(d?.gmail_available),
          canSend: Boolean(d?.can_send),
          canRead: Boolean(d?.can_read),
        }))
        .catch(() => NONE);
    }
    statusPromise.then((v) => {
      if (alive) setStatus(v);
    });
    return () => {
      alive = false;
    };
  }, []);

  return status;
}

/** Whether the signed-in agent can send from their own connected Gmail. */
export default function useMailboxCanSend() {
  return useMailboxStatus().canSend;
}
